import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../firebaseConfig";
import {
  collection,
  addDoc,
 
} from "firebase/firestore";


export const save = createAsyncThunk(
  "data/addData",
  async (newData, { rejectWithValue }) => {
    try {
      const ref = collection(db, "saving");
      const docRef = await addDoc(ref, newData);
      alert('Enregistré avec succès');
      window.location = "/form"
      return { id: docRef.id, ...newData };
    } catch (error) {
      console.log(error)
      alert("Une erreur s'est produite, veuillez réessayer !");
      return rejectWithValue("Échec de l'enregistrement des données. Veuillez réessayer.");
    }
  }
);

export const saveCompta = createAsyncThunk(
  "data/addDataCompta",
  async (newData, { rejectWithValue }) => {
    try {
      const ref = collection(db, "compta");
      const docRef = await addDoc(ref, newData);
      alert('Enregistré avec succès');
      window.location = "/form/compta"
      return { id: docRef.id, ...newData };
    } catch (error) {
      alert("Une erreur s'est produite, veuillez réessayer !");
      return rejectWithValue("Échec de l'enregistrement des données. Veuillez réessayer.");
    }
  }
);



export const dataSlice = createSlice({
  name: "data",
  initialState: {
    isLoading: false,
    data: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(save.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(save.fulfilled, (state, action) => {
        state.data.push(action.payload);
        state.isLoading = false;
      })
      .addCase(save.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      

      .addCase(saveCompta.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(saveCompta.fulfilled, (state, action) => {
        state.data.push(action.payload);
        state.isLoading = false;
      })
      .addCase(saveCompta.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
  },
});
export default dataSlice.reducer;
